<div class="fab-sub-tools"   
     [matTooltip]="tooltip"
     matTooltipClass="mat-tooltip-bigger"
     matTooltipShowDelay="500"
     matTooltipPosition="left"
     (mouseenter)="onMouseEnter($event)"
     (mouseleave)="onMouseLeave($event)">
    <button class="fab-sub-button"
              [class.fab-sub-button-small]="smallFontEnabled"
            mat-mini-fab
            (click)="onActionClick($event)"
            (mouseenter)="onActionMouseEnter($event)"
            (mouseleave)="onActionMouseLeave($event)">
        <mat-icon *ngIf="!!actionIcon"
                  [svgIcon]="actionIcon"
                  style="height:25px;">{{actionIcon}}</mat-icon>
        <mat-icon *ngIf="!!estensaIcon"
                  [fontSet]="enableEstensaFontSet ? 'estensa-icons' : ''"
                  style="height:25px;">{{estensaIcon}}</mat-icon>
    </button>
    <div class="fab-sub-actions" [class.closed]="!isOpen">
        <ng-content></ng-content>
    </div>
</div>
